import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function About() {
  return <section id="a-propos" className="mx-auto max-w-shell px-6 py-24 lg:px-10 lg:py-32" data-id="element-19" data-mp="2ptl1njcgj8bf">
      <div className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-20" data-mp="2trr4iga6d3r2">
        <div className="lg:col-span-4" data-id="element-21" data-mp="2yt80bxdsy00s">
          <Reveal data-id="element-22" data-mp="2yq2csmktn676">
            <p className="text-[11px] uppercase tracking-label text-graphite" data-id="element-23" data-mp="33r9j0h7bfxbq">À propos</p>
            <h2 className="mt-5 font-display text-4xl leading-[1.05] tracking-tight lg:text-5xl" data-id="element-24" data-mp="33pf71se0vfjs">
              Une seule interlocutrice,
              <br data-id="element-25" data-mp="3dgt3tsela198" />
              du relevé au chantier.
            </h2>
          </Reveal>
        </div>

        <div className="lg:col-span-7 lg:col-start-6" data-id="element-26" data-mp="3hhlcajfn024g">
          <Reveal delay={0.06} data-id="element-27" data-mp="3mhr9sg8l8iug">
            <p className="font-display text-2xl leading-snug lg:text-[1.75rem]" data-id="element-28" data-mp="3miivmzcdv27j">
              Après des études en école d’architecture et près de dix ans auprès de professionnels variés du secteur
              et des logiciels BIM, je crée en 2014 la micro-entreprise CBS Dessin.
            </p>
            <p className="mt-6 max-w-2xl text-[15px] leading-relaxed text-graphite" data-id="element-29" data-mp="2gruuhifiksys">
              En 2022, portée par la confiance que mes clients me montrent, et toujours aussi satisfaite de les
              aider à mener à bien leurs projets, CBS Dessin devient DACB. Avec cette nouvelle structure, je
              continue de vous assister dans vos projets neufs ou de rénovation.
            </p>
            <Link to="/a-propos" className="group mt-10 inline-flex items-center gap-3 border-b border-ink pb-1 text-[11px] uppercase tracking-label" data-id="element-30" data-mp="30fv9dzh0vrmk">
              Mon parcours
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-smooth group-hover:translate-x-1" data-id="element-31" data-mp="2qpio251dvufd" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>;
}